var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alertNotFoundCampanha"},[_vm._m(0),_c('div',{staticClass:"buttonContainer"},[_c('router-link',{attrs:{"to":{
        name: 'catalogoRota',
        query: { apenas_ofertas: true, isLoginRequired: true },
      }}},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Ver todas as ofertas")])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('span',[_vm._v("Nenhuma oferta exclusiva disponível no momento.")]),_c('br')])
}]

export { render, staticRenderFns }